import React, { useEffect, useState } from 'react'
import FormModal from './FormModal'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

interface Props {
	AgentsEmailAddress: string
}

const ContactAgent = (props: Props) => {
	const { AgentsEmailAddress } = props
	const [modalVisibility, setmodalVisibility] = useState(false)

	useEffect(() => {
		document.getElementsByTagName('body')[0].style.overflow = modalVisibility ? 'hidden' : 'auto'
	}, [modalVisibility])

	return (
		<GoogleReCaptchaProvider reCaptchaKey="6LcHTe0eAAAAAH8GIFD2CE6i3ojqXkF3UHqUQeih">
			<button
				type="submit"
				className="btn form-submit brand accent btn--wide"
				style={{ width: '100%', marginTop: '10px' }}
				onClick={() => setmodalVisibility(true)}
			>
				Request Appraisal
			</button>
			<FormModal
				open={modalVisibility}
				openModal={() => setmodalVisibility(true)}
				closeModal={() => setmodalVisibility(false)}
				AgentsEmailAddress={AgentsEmailAddress}
			/>
		</GoogleReCaptchaProvider>
	)
}

export default ContactAgent
